import {Typography} from '@mui/material';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import {useDropzone} from 'react-dropzone';
import {renderUpload, shouldRenderUploadProgress} from 'components/FileUpload/commons/UploadRenderUtil';
import './FileUpload.scss';

export const FileUpload = (
  {
    uploadProgress,
    onReject,
    onUpload,
    header,
    description,
    accept,
    uploadText,
    className,
    maxSize,
    style,
    customErrorMessage = {},
  }
) => {
  const [uploadError, setUploadError] = useState('');
  const onDropAccepted = useCallback((files, event) => {
    setUploadError('');
    onUpload && onUpload(files, event);
  }, [onUpload]);

  const onDropRejected = useCallback((files, event) => {
      const firstErrors = files[0]?.errors || [];
      if (firstErrors.length) {
          const message = customErrorMessage[firstErrors[0]?.code] || firstErrors[0]?.message;
          setUploadError(message);
      }
    onReject && onReject(files, event);
  },[onReject]);

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    accept: accept,
    maxSize,
    multiple: false,
    onDropAccepted,
    onDropRejected,
  });

  function rootClassName() {
    const classes = ['FileUpload'];
    if (className) {
      classes.push(className);
    }
    if (isDragActive) {
      classes.push('active');
    }
    if (uploadError) {
        classes.push('error');
    }

    return classes.join(' ');
  }

    return shouldRenderUploadProgress(uploadProgress) ? (
    renderUpload({className, isDragActive, uploadProgress, uploadText})
  ) : (
      <>
          <div className={rootClassName()}
               data-testid="FileUpload"
               role="button"
               aria-label="File Upload"
               style={style}
               {...getRootProps()}>
              <Typography variant="h4" className="header">{header}</Typography>
              {uploadError && <span className="message">{uploadError}</span>}
              <span className="description">{description}</span>
              <input data-testid="file-upload-input" {...getInputProps()}/>
          </div>
      </>
  );
};

FileUpload.propTypes = {
  uploadProgress: PropTypes.number,
  onReject: PropTypes.func,
  onUpload: PropTypes.func.isRequired,
  header: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  accept: PropTypes.string.isRequired,
  uploadText: PropTypes.string,
  className: PropTypes.string,
  maxSize: PropTypes.number,
  style: PropTypes.object,
  customErrorMessage: PropTypes.object,
};

FileUpload.defaultProps = {
  maxSize: Infinity,
};

export default FileUpload;
